import axios from '@/libs/api.request'
export const HomeData = data => {
  return axios.request({
    url: '/company/homedata',
    params: data,
    method: 'get'
  })
}
export const GetStatistics = data => {
  return axios.request({
    url: '/company/statistics',
    params: data,
    method: 'get'
  })
}
export const GetJobRecord = data => {
  return axios.request({
    url: '/company/job/record',
    params: data,
    method: 'get'
  })
}
export const GetChartData = data => {
  return axios.request({
    url: '/company/job/chart',
    params: data,
    method: 'get'
  })
}
export const GetJobPie = data => {
  return axios.request({
    url: '/company/job/pie',
    params: data,
    method: 'get'
  })
}
export const GetDepartmentTrend = data => {
  return axios.request({
    url: '/company/job/trend/department',
    params: data,
    method: 'get'
  })
}
export const GetStaffTrend = data => {
  return axios.request({
    url: '/company/job/trend/staff',
    params: data,
    method: 'get'
  })
}
export const GetMachineTrend = data => {
  return axios.request({
    url: '/company/job/trend/machine',
    params: data,
    method: 'get'
  })
}
export const GetRechargeLog = data => {
  return axios.request({
    url: '/company/recharge/log',
    params: data,
    method: 'get'
  })
}

export const DeleteRechargeLog = data =>{
  return axios.request({
    url:'/company/recharge/log/del',
    data,
    method:'post'
  })
}
